import * as actionTypes from "./actionTypes"
import { authenticationService } from "../../../services/basis/AuthenticationService"
import { history } from "../../../App"
import toaster from "../../../utils/toaster"
import { cartAction, availabilityAction, addProductToAddAction } from "./cart"
import { ecommerceCartsService } from "../../../services/ecommerce/EcommerceCartsService"
import { ecommerceService } from "../../../services/ecommerce/EcommerceService"
import { favorites, slists } from "./slists"
import { smartlistService } from "../../../services/slists/SmartlistService"
import config from "../../../config/config"
import swal from "../../../utils/swal"
import { handleError } from "../../../utils/handleCatch"

export const loginAction = (user) => {
    return {
        type: actionTypes.LOGIN,
        user: user.profile,
        jwt: user.jwt
    }
}

export const login = (data) => {
    return (dispatch, getState) => {
        authenticationService.login(data)
            .then(response => {
                dispatch(loginAction(response.data))
                // get current cart 
                ecommerceCartsService.current()
                    .then(response => {
                        dispatch(cartAction(response.data))
                        localStorage.setItem('cartId', response.data.id);
                        localStorage.setItem('deliveryMode', response.data.deliveryMode);
                        localStorage.setItem('storeId', response.data.storeId);
                        localStorage.setItem('storeDescription', response.data.storeDescription);

                        // get first availability
                        ecommerceService.availability()
                            .then(response => {
                                dispatch(availabilityAction(response.data))
                            }).catch((error) => {
                                handleError(error)
                                console.log(error);
                            })

                        // add unauthenticathed product
                        if (getState().cart.productToAdd) {
                            const item = getState().cart.productToAdd;
                            ecommerceCartsService.store(response.data.id, item.barcode, item.amount, item.um)
                                .then((response) => {
                                    const um = response.data.updatedProduct.um;
                                    dispatch(addProductToAddAction(response.data.cart))
                                    toaster.standard(`Hai ${item.amount} ${um} ${response.data.updatedProduct.description} nel carrello`)
                                }).catch((error) => {
                                    console.log(error);
                                    handleError(error)
                                    toaster.error(error.message);
                                })
                        }
                    }).catch((error) => {
                        console.log(error);
                    })
                smartlistService.getFavorites()
                    .then(response => {
                        dispatch(favorites(response.data))
                    }).catch((error) => {
                        handleError(error)
                        console.log(error);
                    })
                // get slists
                smartlistService.getSlists()
                    .then(response => {
                        dispatch(slists(response.data))
                    }).catch((error) => {
                        handleError(error)
                        console.log(error);
                    })
            }).catch((error) => {
                dispatch(logoutAction());
                toaster.error("Credenziali errate")
            })
    }
};

export const logoutAction = () => {
    return {
        type: actionTypes.LOGOUT,
        user: null
    }
}

export const logout = () => {
    return dispatch => {
        history.push("/")
        dispatch(logoutAction())
        dispatch(cartAction(null))
        authenticationService.logout()
            .then(response => {
                dispatch(cartAction(null))
            }).catch((error) => {
                console.log(error);
            })
    }
};

export const isLoggedAction = (user) => {
    return {
        type: actionTypes.IS_LOGGED,
        user: user
    }
}

export const isLogged = () => {
    return dispatch => {
        authenticationService.isLogged()
            .then(response => {
                dispatch(isLoggedAction(response.data))
            }).catch((error) => {
                handleError(error)
                console.log(error);
            })
    }
};

export const coordinateAction = (latitude, longitude) => {
    return {
        type: actionTypes.COORDINATE,
        latitude: latitude,
        longitude: longitude
    }
}

export const coordinate = (latitude, longitude) => {
    return dispatch => {
        dispatch(coordinateAction(latitude, longitude))
    }
};

export const updateUserAction = (user) => {
    return {
        type: actionTypes.USER_UPDATE,
        user: user
    }
}

export const updateUser = (data) => {
    return dispatch => {
        authenticationService.updateUser(data)
            .then(response => {
                dispatch(updateUserAction(response.data))
                swal.success('Profilo aggiornato con successo');
            }).catch((error) => {
                handleError(error)
                swal.error('Errore durante l\'aggiornamento del profilo');
                console.log(error);
            })
    }
};

export const overlayAction = (isActive) => {
    return {
        type: actionTypes.OVERLAY,
        showOverlay: isActive
    }
}

export const overlay = (isActive) => {
    return dispatch => {
        dispatch(overlayAction(isActive))
    }
};

export const deleteUser = () => {
    return dispatch => {
        authenticationService.deleteUser()
            .then(response => {
                swal.success('Richiesta eliminazione profilo inviata, verrà eseguita il prima possibile.');
            }).catch((error) => {
                handleError(error)
                swal.error('Errore nell\'invio della richiesta');
                console.log(error);
            })
    }
};